import { INLINES } from '@contentful/rich-text-types';
import { renderRichText } from 'gatsby-source-contentful/rich-text';

import { getHyperlinkComponent } from './getHyperlinkComponent';

import type { FC } from 'react';
import type { BaseRichTextType, RichTextType } from './types';

export interface RichTextProps {
  richText: RichTextType;
}

const renderRichTextOptions = {
  renderNode: {
    /*
     * This allows us to override a specific renderer, eg. links use our GatsbyLink.
     * There are a lot, see: `INLINES`, `MARKS`, and `BLOCKS`
     * Also: https://www.contentful.com/developers/docs/javascript/tutorials/rendering-contentful-rich-text-with-javascript/
     */
    [INLINES.HYPERLINK]: getHyperlinkComponent,
  },
};

export const RichText: FC<RichTextProps> = ({ richText }) => (
  <>
    {renderRichText(
      /*
       * NOTE: See notes around BaseRichTextType, this assertion is "wrong"
       * However, I believe it's in Contentful/Gatsby, not us.
       */
      richText as BaseRichTextType,
      renderRichTextOptions
    )}
  </>
);
